import React, { useEffect, useState } from "react";
import axios from "axios";
import Pagination from "../../Pagination";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import MetricNavbar from "./MetricNavbar";
import * as XLSX from "xlsx";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function RecruiterPerformanceDashboard() {
  const [metrics, setMetrics] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedRecruiter, setSelectedRecruiter] = useState("");
  const [filteredMetrics, setFilteredMetrics] = useState([]);
  const [selectedMetric, setSelectedMetric] = useState("closures");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 6;

  const metricOptions = {
    closures: "Closures",
    screening_volume: "Screening Volume",
    // avg_time_to_close: "Avg Time of Close",
    // resume_to_hire: "Resume to Hire %",
    // shortlist_to_hire_ratio: "Shortlist to Hire Ratio",
    time_to_hire: "Time to Hire",
    profiles_submitted: "Profiles Submitted",
    offers_released: "Offers Released",
    candidates_joined: "Candidates Joined",
    // offer_to_joined_ratio: "Offer to Joined Ratio",
    // submitted_to_offer_ratio: "Submitted to Offer Ratio",
  };

  const metricColors = {
    closures: "#6f42c1",
    screening_volume: "#6f42c1",
    avg_time_to_close: "#6f42c1",
    resume_to_hire: "#6f42c1",
    shortlist_to_hire_ratio: "#6f42c1",
    time_to_hire: "#6f42c1",
    profiles_submitted: "#6f42c1",
    offers_released: "#6f42c1",
    candidates_joined: "#6f42c1",
    offer_to_joined_ratio: "#6f42c1",
    submitted_to_offer_ratio: "#6f42c1",
  };

  // useEffect(() => {
  //   const fetchMetrics = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_BASE_URL}/screener/api-metrics/`
  //       );
  //       const backendData = response.data;

  //       const recruiterEmails = Array.from(
  //         new Set([
  //           ...backendData.screening_volume_per_recruiter.map(
  //             (r) => r.user__email
  //           ),
  //           ...backendData.profiles_submitted_per_recruiter.map(
  //             (r) => r.user__email
  //           ),
  //           ...backendData.offers_per_recruiter.map(
  //             (r) => r.candidate__user__email
  //           ),
  //           // Add other recruiter-related fields here if needed
  //         ])
  //       );

  //       const data = recruiterEmails.map((email) => {
  //         return {
  //           recruiter_id: email,
  //           closures:
  //             backendData.closures_per_recruiter?.find(
  //               (r) => r.created_by__email === email
  //             )?.closures || 0,
  //           screening_volume:
  //             backendData.screening_volume_per_recruiter?.find(
  //               (r) => r.user__email === email
  //             )?.screened || 0,
  //           // avg_time_to_close: backendData.avg_time_to_close_jd || 0,
  //           // resume_to_hire: parseFloat(
  //           //   backendData.resume_to_hire_conversion_rate || 0
  //           // ).toFixed(2),
  //           // shortlist_to_hire_ratio: parseFloat(
  //           //   backendData.shortlisted_to_hire_ratio || 0
  //           // ).toFixed(2),
  //           time_to_hire:
  //             backendData.time_to_hire_per_recruiter?.find(
  //               (r) => r.user__email === email
  //             )?.time || 0,
  //           profiles_submitted:
  //             backendData.profiles_submitted_per_recruiter?.find(
  //               (r) => r.user__email === email
  //             )?.count || 0,
  //           offers_released:
  //             backendData.offers_per_recruiter?.find(
  //               (r) => r.candidate__user__email === email
  //             )?.offers || 0,
  //           candidates_joined:
  //             backendData.candidates_joined_per_recruiter?.find(
  //               (r) => r.user__email === email
  //             )?.joined || 0,
  //           // submitted_to_offer_ratio: parseFloat(
  //           //   backendData.submitted_to_offer_ratio || 0
  //           // ).toFixed(2),
  //           // offer_to_joined_ratio: parseFloat(
  //           //   backendData.offer_to_joined_ratio || 0
  //           // ).toFixed(2),
  //         };
  //       });

  //       setMetrics(data);
  //       setFilteredMetrics(data);
  //     } catch (err) {
  //       setError("Failed to fetch metrics.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchMetrics();
  // }, []);

  useEffect(() => {
    const fetchMetrics = async () => {
      const storedClient = localStorage.getItem("client");

      // Convert stored values to numbers
      const client_id = storedClient ? Number(storedClient) : null;

      // Debugging: Log retrieved values
      console.log("Fetching data with:", { client_id });

      // Ensure client_id and user_id are valid before making the request
      if (!client_id) {
        console.error("Missing client_id . Please log in again.");
        return;
      }
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/screener/api-metrics/?client_id=${client_id}`
        );
        const data = response.data;

        const recruiters = {};

        const add = (key, updater) => {
          const email =
            key?.recruiter_email ||
            key?.recruiter ||
            key?.user__email ||
            key?.candidate__user__email;
          if (!email) return;
          if (!recruiters[email]) {
            recruiters[email] = { recruiter_id: email };
          }
          updater(recruiters[email], key);
        };

        data.closures_per_recruiter?.forEach((r) =>
          add(r, (rec, row) => (rec.closures = row.closures))
        );
        data.screening_volume_per_recruiter?.forEach((r) =>
          add(r, (rec, row) => (rec.screening_volume = row.screened))
        );
        data.time_to_hire_per_recruiter?.forEach((r) =>
          add(
            r,
            (rec, row) => (rec.time_to_hire = row.average_time_to_hire_days)
          )
        );
        data.profiles_submitted_per_recruiter?.forEach((r) =>
          add(r, (rec, row) => (rec.profiles_submitted = row.count))
        );
        data.offers_per_recruiter?.forEach((r) =>
          add(r, (rec, row) => (rec.offers_released = row.offers))
        );
        data.candidates_joined_per_recruiter?.forEach((r) =>
          add(r, (rec, row) => (rec.candidates_joined = row.joined))
        );

        const result = Object.values(recruiters);
        setMetrics(result);
        setFilteredMetrics(result);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch recruiter performance data.");
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, []);

  const exportToExcel = () => {
    const exportData = metrics.map((item) => {
      const row = { "Recruiter ID": item.recruiter_id };
      Object.entries(metricOptions).forEach(([key, label]) => {
        row[label] = item[key];
      });
      return row;
    });

    // ✅ Compute total row using current metrics
    const totalRow = { "Recruiter ID": "Total" };
    Object.entries(metricOptions).forEach(([key, label]) => {
      const total = metrics.reduce(
        (sum, row) => sum + (parseFloat(row[key]) || 0),
        0
      );
      totalRow[label] = total;
    });

    exportData.push(totalRow);

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // ✅ Adjust column widths based on header and cell content
    worksheet["!cols"] = Object.keys(exportData[0]).map((key) => {
      const maxLength = Math.max(
        key.length,
        ...exportData.map((row) => String(row[key] || "").length)
      );
      return { wch: maxLength + 2 };
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Recruiter Performance");
    XLSX.writeFile(workbook, "Recruiter_Performance_Report.xlsx");
  };

  const metricTotals = {};
  Object.keys(metricOptions).forEach((key) => {
    metricTotals[key] = filteredMetrics.reduce(
      (sum, row) => sum + (parseFloat(row[key]) || 0),
      0
    );
  });

  const handleRecruiterFilter = (e) => {
    const recruiterId = e.target.value;
    setSelectedRecruiter(recruiterId);
    const filtered = recruiterId
      ? metrics.filter((m) => m.recruiter_id === recruiterId)
      : metrics;
    setFilteredMetrics(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = metrics.filter(
      (m) =>
        m.recruiter_id.toLowerCase().includes(query) ||
        m.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredMetrics(filtered);
    setCurrentPage(1);
  };

  const chartData = {
    labels: filteredMetrics.map((m) => m.recruiter_id),
    datasets: [
      {
        label: metricOptions[selectedMetric],
        data: filteredMetrics.map((m) => m[selectedMetric]),
        backgroundColor: metricColors[selectedMetric],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredMetrics.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredMetrics.length / rowsPerPage);

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <h3 className="text-center text-dark">&nbsp;Loading metrics.... </h3>
      </div>
    );
  }

  if (error) {
    return <div className="text-danger text-center py-5">Error: {error}</div>;
  }

  return (
    <>
      <MetricNavbar />
      <div className="container py-4">
        <h2 className="text-center mb-4 font_header">
          Recruiter Performance Dashboard
        </h2>

        <div className="row mb-3">
          <div className="col-md-3">
            <label htmlFor="recruiterSelect" className="form-label fw-semibold">
              Filter by Recruiter:
            </label>
            <select
              id="recruiterSelect"
              className="form-select border-dark"
              value={selectedRecruiter}
              onChange={handleRecruiterFilter}
            >
              <option value="">All Recruiters</option>
              {metrics.map((m, index) => (
                <option key={index} value={m.recruiter_id}>
                  {m.recruiter_id}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label htmlFor="metricSelect" className="form-label fw-semibold">
              Select Metric:
            </label>
            <select
              id="metricSelect"
              className="form-select border-dark"
              value={selectedMetric}
              onChange={(e) => setSelectedMetric(e.target.value)}
            >
              {Object.entries(metricOptions).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label htmlFor="searchInput" className="form-label fw-semibold">
              Search Recruiter ID:
            </label>
            <input
              type="search"
              id="searchInput"
              className="form-control border-dark"
              placeholder="Search by ID..."
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
          <div className="col-md text-lg-end mt-3">
            <button className="btn btn-outline-info" onClick={exportToExcel}>
              Download
            </button>
          </div>
        </div>

        <div className="mb-5">
          <h5 className="text-center mb-3">
            {metricOptions[selectedMetric]} by Recruiter
          </h5>
          <Bar data={chartData} options={chartOptions} />
        </div>

        <div className="table-responsive table-wrapper text-center">
          <table className="table table-bordered table-hover border-dark">
            <thead className="table-center tb_header text-center">
              <tr>
                <th style={{ whiteSpace: "nowrap" }}>Recruiter ID</th>
                {Object.entries(metricOptions).map(([key, label]) => (
                  <th key={key} style={{ whiteSpace: "nowrap" }}>
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentRows.map((rec, index) => (
                <tr key={index}>
                  <td>{rec.recruiter_id}</td>
                  {Object.keys(metricOptions).map((key) => (
                    <td key={key}>{rec[key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ fontWeight: "bold", backgroundColor: "#f9f9f9" }}>
                <td>Total</td>
                {Object.keys(metricOptions).map((key) => (
                  <td key={key}>{metricTotals[key]}</td>
                ))}
              </tr>
            </tfoot>
          </table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          paginate={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
}

export default RecruiterPerformanceDashboard;
